import { color, palette } from "../../theme"

export const viewPresets = {
  square: {
    size: 28,
    color: color.primary,
    iconDone: ["fas", "check-square"],
    iconNotDone: ["far", "square"],
  },
  circle: {
    size: 24,
    color: color.primary,
    iconDone: ["fas", "check-circle"],
    iconNotDone: ["far", "circle"],
  },
  toDoCheck: {
    size: 24,
    color: palette.Bright_green,
    iconDone: ["fas", "check-circle"],
    iconNotDone: ["far", "circle"],
  },
  checkList: {
    size: 24,
    color: palette.Dark_pink,
    iconDone: ["fas", "check-circle"],
    iconNotDone: ["far", "circle"],
  },
  star: {
    size: 32,
    color: color.primary,
    iconDone: ["fas", "star"],
    iconNotDone: ["far", "star"],
  },
}

export type CheckboxPresets = keyof typeof viewPresets
